// Mock data for The Fitness Junction website

export const navigationLinks = [
  { id: 1, name: 'Home', href: '#home' },
  { id: 2, name: 'About Us', href: '#about' },
  { id: 3, name: 'Programs', href: '#programs' },
  { id: 4, name: 'Contact Us', href: '#contact' }
];

export const programs = [
  {
    id: 1,
    title: 'Weight Training',
    description: 'Build strength and muscle with our expert-guided weight training programs designed for all fitness levels.',
    image: 'https://images.unsplash.com/photo-1517836357463-d25dfeac3438',
    icon: 'Dumbbell'
  },
  {
    id: 2,
    title: 'Zumba',
    description: 'Dance your way to fitness with high-energy Zumba classes that combine fun music and effective cardio.',
    image: 'https://images.unsplash.com/photo-1527933053326-89d1746b76b9',
    icon: 'Music'
  },
  {
    id: 3,
    title: 'Dance',
    description: 'Express yourself through movement with our diverse dance fitness programs for all skill levels.',
    image: 'https://images.unsplash.com/photo-1524594152303-9fd13543fe6e',
    icon: 'Sparkles'
  },
  {
    id: 4,
    title: 'Cardio',
    description: 'Boost your endurance and burn calories with our intensive cardio training sessions.',
    image: 'https://images.unsplash.com/photo-1608138278545-366680accc66',
    icon: 'Heart'
  },
  {
  id: 5,
  title: "Yoga",
  description: "Improve flexibility, balance, and inner strength through guided yoga sessions designed for all levels.",
  image: "https://images.unsplash.com/photo-1552196563-55cd4e45efb3?q=80&w=1600&auto=format&fit=crop",
  icon: "Sparkles"
}
];

export const aboutFeatures = [
  { id: 1, text: 'Certified Trainers' },
  { id: 2, text: 'Modern Equipment' },
  { id: 3, text: 'Friendly Environment' },
  { id: 4, text: 'Personalized Plans' }
];

export const contactInfo = {
  phone: '+91 96811 25006',
  email: 'santanusaha@thefitnessjunction.online',
  address: 'Arabindrapally, opposite Bharat petroleum, Helabattala, Barasat, West Bengal 700124',
  mapUrl: 'https://maps.google.com/maps?q=Arabindrapally,+Helabattala,+Barasat,+West+Bengal+700124&t=&z=15&ie=UTF8&iwloc=&output=embed'
};

export const socialLinks = [
  { id: 1, name: 'Instagram', url: 'https://www.instagram.com/the_fitness_junctions_?igsh=ajlycTF0NHk5c3Nl', icon: 'Instagram' },
  { id: 2, name: 'Facebook', url: 'https://www.facebook.com/share/1bWGCAcg9G/?mibextid=wwXIfr', icon: 'Facebook' }
];

export const heroContent = {
  title: 'Transform Your Body at The Fitness Junction',
  subtitle: 'Strength. Energy. Results.',
  backgroundImage: 'https://images.unsplash.com/photo-1550345332-09e3ac987658'
};

export const aboutContent = {
  title: 'About The Fitness Junction',
  description: 'At The Fitness Junction, we believe fitness is a journey, not a destination. Our state-of-the-art facility combines cutting-edge equipment with expert trainers to help you achieve your fitness goals. Whether you\'re a beginner or an experienced athlete, we provide personalized training programs tailored to your needs.',
  mission: 'Our mission is to empower individuals to transform their lives through fitness. We create a supportive, motivating environment where every member can push their limits and discover their true potential.',
  image: 'https://images.pexels.com/photos/33966785/pexels-photo-33966785.jpeg'
};

// Mock form submission
export const submitContactForm = (formData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('Form submitted:', formData);
      resolve({ success: true, message: 'Thank you for contacting us! We will get back to you soon.' });
    }, 1000);
  });
};


